import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLlayerTreeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0C11.45 0 11 0.45 11 1V23C11 23.55 11.45 24 12 24C12.55 24 13 23.55 13 23V1C13 0.45 12.55 0 12 0Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLlayerTreeIcon.displayName = 'HierLlayerTreeIcon';
